import { render, staticRenderFns } from "./handleOrder.vue?vue&type=template&id=fceec246&scoped=true&"
import script from "./handleOrder.vue?vue&type=script&lang=js&"
export * from "./handleOrder.vue?vue&type=script&lang=js&"
import style0 from "./handleOrder.vue?vue&type=style&index=0&id=fceec246&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fceec246",
  null
  
)

export default component.exports